import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Warranty} from '../../../models/warranties/warranty.model';
import {HttpService} from '../../../services/http.service';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';
import {Router} from '@angular/router';
import {ErrorMessageTranslatorService} from '../../../error-message-translator.service';

@Component({
  selector: 'app-accept-modal',
  templateUrl: './accept-modal.component.html',
  styleUrls: ['./accept-modal.component.scss']
})
export class AcceptModalComponent implements OnInit {

  constructor(private modalService: NgbModal, private router: Router, private http: HttpService,
              private errorMessageTranslator: ErrorMessageTranslatorService) {
  }
  @ViewChild('content') content;
  closeResult = '';

  @Input()
  warranty: Warranty;

  private static getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public openModal() {
    this.modalService.open(this.content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${AcceptModalComponent.getDismissReason(reason)}`;
    });
  }

  submitWarranty() {
    this.http.saveWarranty(this.warranty).subscribe(() => {
      this.http.submitWarranty(this.warranty.id).subscribe(() => {
        this.modalService.dismissAll();
        SweetUtil.showSuccess('Warranty Successfully Submitted').then();
        this.router.navigate(['/dashboard']).then();
      }, error => {
        this.errorMessageTranslator.translateAndShowErrorMessageRequiringSpecialRequest(error);
      });
    }, (error) => {
      this.errorMessageTranslator.translateAndShowErrorMessageRequiringSpecialRequest(error, false);
    });
  }

  ngOnInit(): void {
  }
}
